import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import clsx from 'clsx';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  overlayClassName?: string;
  modalContentClassName?: string;
  closeOnOverlayClick?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className,
  overlayClassName,
  modalContentClassName,
  closeOnOverlayClick = true,
}) => {
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setClosing(false);
      onClose();
    }, 300);
  };

  if (!isOpen && !closing) return null;

  return (
    <div 
      className={clsx(
        styles.modalOverlay,
        overlayClassName,
        closing ? styles.fadeOut : styles.fadeIn
      )}
      onClick={closeOnOverlayClick ? handleClose : undefined}
    >
      <div 
        className={clsx(
          styles.modalContainer,
          className,
          closing ? styles.slideDown : styles.slideUp
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={clsx(styles.modalContent, modalContentClassName)}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal; 